import React from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'

import { Flex, H4, P, HR } from 'ui/bend'

import { useUserContext } from 'context'
import { MyPraticeCards } from './MyPraticeCards'
import { storeEventInLocalStorage } from 'gtm/pushEvents'

const HeaderSection = styled(Flex)(() =>
  css({
    justifyContent: 'space-between'
  })
)

const NameHeader = styled(H4)(() =>
  css({
    letterSpacing: '-0.72px',
    fontWeight: '400'
  })
)

const PreferenceLink = styled(P)(() =>
  css({
    letterSpacing: '0.352px',
    textDecorationLine: 'underline',
    textDecorationSkipInk: 'none',
    textUnderlinePosition: 'from-font'
  })
)

const SummarySection = styled(Flex)(() =>
  css({
    gap: '32px',
    alignItems: 'center',
    justifyContent: 'center',
    '@media all and (max-width: 640px)': {
      gap: '16px',
    }
  })
)

const Summary = styled(Flex)(() =>
  css({
    flexDirection: 'column',
    alignItems: 'center',
    width: '161px',
    '@media all and (max-width: 640px)': {
      width: '110px'
    }
  })
)

const SnapshotText = styled(P)(() =>
  css({
    textAlign: 'center',
    fontSize: '12px',
    textTransform: 'uppercase',
    marginBottom: '8px'
  })
)

const SummaryNumber = styled(P)(() =>
  css({
    fontSize: '32px',
    lineHeight: '130%'
  })
)

const SummaryText = styled(P)(() =>
  css({
    fontSize: '15px',
    lineHeight: '12px',
    '@media all and (max-width: 640px)': {
      fontSize: '11px'
    }
  })
)

export const MyPraticeSummary = () => {
  const { user, contextData } = useUserContext()

  const myPreferencesClick = () =>
    storeEventInLocalStorage({
      event: 'my_preferences_click',
      first_time: !contextData?.user_answered_survey,
      location: 'homepage'
    })

  return (
    <>
      <Flex style={{ flexDirection: 'column', gap: '18px' }}>
        <HeaderSection>
          <NameHeader>Hello, {user.firstName}</NameHeader>
          <PreferenceLink
            onClick={myPreferencesClick}
            as='a'
            href='/surveys/onboarding?start=true'
          >
            My Preferences
          </PreferenceLink>
        </HeaderSection>
        <div style={{ padding: '8px 0' }}>
          <SnapshotText>30-Day Snapshot</SnapshotText>
          <SummarySection>
            <Summary>
              <SummaryNumber>
                {user?.myPracticeSnapshot?.snapshot?.completedClassesCount}
              </SummaryNumber>
              <SummaryText>Classes Completed</SummaryText>
            </Summary>
            <Summary>
              <SummaryNumber>
                {user?.myPracticeSnapshot?.snapshot?.activeDays}
              </SummaryNumber>
              <SummaryText>Active Days</SummaryText>
            </Summary>
            <Summary>
              <SummaryNumber>
                {user?.myPracticeSnapshot?.snapshot?.weekStreak}
              </SummaryNumber>
              <SummaryText>Week Streak</SummaryText>
            </Summary>
          </SummarySection>
        </div>
        <MyPraticeCards />
      </Flex>
    </>
  )
}
